import { cva } from '@/styled-system/css';

export const switchTrackRecipe = cva({
  base: {
    borderRadius: 'Switch.Track.md',
    display: 'inline-block',
    position: 'relative',
    userSelect: 'none',
    transition: {
      _motionReduce: 'none',
      _motionSafe: '{transitions.Switch.Track}',
    },
  },
  variants: {
    disabled: {
      true: {
        opacity: 'disabled',
        cursor: 'default',
      },
      false: {
        _hover: {
          backgroundColor: 'Switch.Track.bg.hover',
        },
        _active: {
          backgroundColor: 'Switch.Track.bg.pressed',
        },
      },
    },
    checkedState: {
      true: {
        backgroundColor: 'Switch.Track.bg.selected',
      },
      false: {
        backgroundColor: 'Switch.Track.bg.default',
      },
    },
    size: {
      md: {
        height: 'Switch.Track.md.height',
        width: 'Switch.Track.md.width',
      },
      lg: {
        height: 'Switch.Track.lg.height',
        width: 'Switch.Track.lg.width',
      },
    },
  },
  compoundVariants: [
    {
      checkedState: true,
      disabled: false,
      css: {
        _hover: {
          backgroundColor: 'Switch.Track.bg.selectedHover',
        },
        _active: {
          backgroundColor: 'Switch.Track.bg.selectedPressed',
        },
      },
    },
  ],
});
